/**
 * Landings por intención (/habitaciones-temporales, etc.)
 * Estrategia SEO (Fase captación): noindex + canonical al marketplace B2C.
 * No van en sitemap — misma idea que consolidar duplicados hacia /encuentratucoliving.
 */

const COLIVING_MARKETPLACE_HUB = '/encuentratucoliving';

const ACCOMMODATION_TYPE_HUB_PATHS = [
  '/habitaciones-temporales',
  '/habitaciones-todo-incluido',
  '/apartamentos-flexliving',
  '/alojamiento-nomadas-digitales',
  '/alojamiento-temporal-profesionales',
];

function normalizePath(source) {
  if (!source || typeof source !== 'string') return '';
  return source.split('?')[0].toLowerCase();
}

function isAccommodationTypeSearchPath(source) {
  const path = normalizePath(source);
  if (!path) return false;
  return ACCOMMODATION_TYPE_HUB_PATHS.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

/** Slug de ciudad en /habitaciones-temporales/madrid (primer segmento tras el hub). */
function getAccommodationTypeCitySlugFromPath(source) {
  const path = normalizePath(source);
  if (!path) return '';
  for (const prefix of ACCOMMODATION_TYPE_HUB_PATHS) {
    if (path === prefix) return '';
    if (path.startsWith(`${prefix}/`)) {
      const rest = path.slice(prefix.length + 1);
      const segment = rest.split('/')[0];
      return segment || '';
    }
  }
  return '';
}

function buildColivingCanonicalUrl(siteUrl, citySlug) {
  const origin = String(siteUrl || '').replace(/\/$/, '');
  const slug = citySlug ? String(citySlug).toLowerCase().trim() : '';
  if (!slug) return `${origin}${COLIVING_MARKETPLACE_HUB}`;
  return `${origin}${COLIVING_MARKETPLACE_HUB}/${slug}`;
}

module.exports = {
  COLIVING_MARKETPLACE_HUB,
  ACCOMMODATION_TYPE_HUB_PATHS,
  isAccommodationTypeSearchPath,
  getAccommodationTypeCitySlugFromPath,
  buildColivingCanonicalUrl,
};
